export default __webpack_public_path__ + "static/media/parking.66ecd00d.svg";